import { useMemo } from "react";
import { useScheduleTemplates } from "@api/scheduleTemplate.api";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { resolvePickerTemplates } from "./schedulePickerTemplates";

export function usePanelScheduleTemplates(entityId: number) {
    const { schedules: isSchedulesEnabled } = useTypedFlags();
    const scheduleTemplatesQuery = useScheduleTemplates({
        enabled: isSchedulesEnabled,
    });
    return useMemo(
        () =>
            resolvePickerTemplates({
                templates: scheduleTemplatesQuery.data,
                entityId,
            }),
        [scheduleTemplatesQuery.data, entityId],
    );
}
